module.exports = __webpack_public_path__ + "assets/img/code-dy-1f346cbe.png";